import React, { useRef } from 'react';

/** 3D perspective tilt + cursor spotlight. Tilt is disabled for touch / reduced motion via CSS. */
function TiltCard({ as: Tag = 'article', className = '', children, max = 9, ...rest }) {
  const ref = useRef(null);

  const onMove = (e) => {
    const el = ref.current;
    if (!el || e.pointerType === 'touch') return;
    const r = el.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width;
    const y = (e.clientY - r.top) / r.height;
    el.style.setProperty('--rx', `${(0.5 - y) * max}deg`);
    el.style.setProperty('--ry', `${(x - 0.5) * max}deg`);
    el.style.setProperty('--mx', `${x * 100}%`);
    el.style.setProperty('--my', `${y * 100}%`);
  };
  const onLeave = () => {
    const el = ref.current;
    if (!el) return;
    el.style.setProperty('--rx', '0deg');
    el.style.setProperty('--ry', '0deg');
  };

  return (
    <Tag ref={ref} className={`fx-tilt ${className}`} onPointerMove={onMove} onPointerLeave={onLeave} {...rest}>
      <span className="fx-tilt__glow" aria-hidden="true" />
      {children}
    </Tag>
  );
}

export default TiltCard;
